import { gql } from "@apollo/client"; import { useLazyQuery } from "@apollo/client/react"; import React, { useState, useEffect, useRef } from 'react';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { Outlet } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import ErrorDialog from '../../../components/ErrorDialog';
import { Avatar, Box, Button, Card, CardContent, InputAdornment, Stack, TextField } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import PersonIcon from '@mui/icons-material/Person';
import DeleteIcon from '@mui/icons-material/Delete';



export default function SeccionCliente({ delegaciones, clientesSeleccionados, setClientesSeleccionados }) {

  const [datos, setDatos] = useState('');
  const [dataOriginal, setDataOriginal] = useState('');

  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  const txtBuscar = useRef(null);

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  useEffect(() => {
    txtBuscar.current.focus();
    getClientes({ variables: { delegaciones: delegaciones } });
  }, [delegaciones]);

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  const QGetClientesByDelegacion = gql`
        query QGetClientesByDelegacionArray ($delegaciones: [Int!]!) {
            clientesByDelegacionArray (delegaciones: $delegaciones)
            {
                success,
                error,
                valorEsperado {
                    cod_Cliente,
                    nom_Com,
                    cUIT,
                    condicionIVA,
                    domicilio,
                    localidad,
                    provincia
                }
            }
    }`;

  const [getClientes, { error: errorClientes, data: dataClientes }] = useLazyQuery(QGetClientesByDelegacion, {
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    if (!dataClientes?.clientesByDelegacionArray?.success) return;
    const dataAll = dataClientes.clientesByDelegacionArray.valorEsperado;
    setDatos(dataAll);
    setDataOriginal(dataAll);
  }, [dataClientes]);

  useEffect(() => {
    if (errorClientes) {
      setMensajeError("ERRORDB");
    }
  }, [errorClientes]);

  const handleSearch = () => {
    // si se ingresó texto a buscar (al menos 3 caracteres) --> filtro, sino retorno todos los registros
    // originales consultados
    if (txtBuscar.current.value != "") {
      if (txtBuscar.current.value.length >= 3) {
        setDatos(dataOriginal.filter((dataOriginal) => {
          const codClienteBuscar = dataOriginal.cod_Cliente.toLowerCase();
          const nombreBuscar = dataOriginal.nom_Com.toLowerCase();
          const cuitBuscar = dataOriginal.cUIT.toLowerCase();
          const domicilioBuscar = dataOriginal.domicilio.toLowerCase();
          const localidadBuscar = dataOriginal.localidad.toLowerCase();
          const provinciaBuscar = dataOriginal.provincia.toLowerCase();

          const inputBuscar = txtBuscar.current.value.toLowerCase();
          return (
            codClienteBuscar.includes(inputBuscar) ||
            nombreBuscar.includes(inputBuscar) ||
            cuitBuscar.includes(inputBuscar) ||
            domicilioBuscar.includes(inputBuscar) ||
            localidadBuscar.includes(inputBuscar) ||
            provinciaBuscar.includes(inputBuscar));

        }
        ));
      }
    } else {
      getClientes({ variables: { delegaciones: delegaciones } });
      setDatos(dataOriginal);
    }
  };

  const handleClean = () => {
    txtBuscar.current.value = "";
    handleSearch();
    txtBuscar.current.focus();
  };

  const generarGrilla = () => {
    const columns = [

      { field: 'cod_Cliente', headerName: 'Código', minWidth: 60, flex: 0.2, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center' },
      { field: 'nom_Com', headerName: 'Nombre Comercial', minWidth: 80, flex: 0.4, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center' },
      { field: 'cUIT', headerName: 'CUIT', minWidth: 60, flex: 0.2, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center' },
      { field: 'domicilio', headerName: 'Domicilio', minWidth: 80, flex: 0.4, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center' },
      { field: 'localidad', headerName: 'Localidad', minWidth: 80, flex: 0.4, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center' },
      { field: 'provincia', headerName: 'Provincia', minWidth: 80, flex: 0.4, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center' }];



    return columns;
  };

  const generarClientesSeleccionados = () => {
    const columns = [

      { field: 'cod_Cliente', headerName: 'Código', minWidth: 60, flex: 0.2, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center' },
      { field: 'nom_Com', headerName: 'Nombre Comercial', minWidth: 80, flex: 0.4, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center' },
      { field: 'cUIT', headerName: 'CUIT', minWidth: 60, flex: 0.2, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center' },
      { field: 'domicilio', headerName: 'Domicilio', minWidth: 80, flex: 0.4, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center' },
      { field: 'localidad', headerName: 'Localidad', minWidth: 80, flex: 0.4, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center' },
      { field: 'provincia', headerName: 'Provincia', minWidth: 80, flex: 0.4, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center' },
      {
        headerName: 'Acc.', align: 'center', flex: 0.1, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center',
        renderCell: (params) => {

          return (
            <DeleteIcon
              sx={{ color: '#717171', cursor: 'pointer', fontSize: '14pt' }}
              onClick={() => borrarClienteSeleccionado(params.row)}
              titleAccess='Borrar Cliente seleccionado' />);


        }
      }];


    return columns;
  };

  // Click sobre fila de la grilla de búsqueda de clientes disponibles
  const handleRowClick = (params) => {
    let agregar = true;

    if (clientesSeleccionados != null && clientesSeleccionados.length > 0) {
      // verifico que no haya sido seleccionado anteriormente
      const nodo = clientesSeleccionados.filter((item) => item.cod_Cliente === params.row.cod_Cliente);
      if (nodo.length > 0) {
        agregar = false;
        toast.error("El Cliente ya se encuentra seleccionado");
      }
    }

    if (agregar) {
      setClientesSeleccionados([...clientesSeleccionados, params.row]);
    }
  };

  const borrarClienteSeleccionado = (rol) => {
    setClientesSeleccionados((clientesSeleccionados) => clientesSeleccionados.filter((item) => item.cod_Cliente !== rol.cod_Cliente));
  };

  return (
    <>
      <Stack direction="row" spacing={100} alignItems="center">
        <Box className='botonera-superior-left-search'>
          <TextField
            className="input-300"
            label="Filtrar Cliente"
            name="txtBuscar"
            size="small"
            type="text"
            variant="outlined"
            inputRef={txtBuscar}
            onKeyUp={handleSearch}
            InputProps={{
              endAdornment:
                <InputAdornment position="end">
                  <SearchIcon
                    onClick={handleSearch}
                    sx={{ cursor: 'pointer' }} />

                  <ClearIcon
                    onClick={handleClean}
                    sx={{ cursor: 'pointer' }} />

                </InputAdornment>

            }} />

        </Box>
      </Stack>
      <br />

      <DataGridGenerico
        columns={generarGrilla()}
        onRowClick={handleRowClick}
        rows={datos}
        toolbar={false} />


      <br /><br />

      <h4>Clientes seleccionados:</h4>
      <DataGridGenerico
        columns={generarClientesSeleccionados()}
        rows={clientesSeleccionados}
        toolbar={false} />


      <Outlet />



      <ErrorDialog
        id="dlg-error-paciente"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />


    </>);


};